import React from 'react'

export default props => {
  return (
    <svg
      viewBox="0 0 51 51"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <g
        id="Pod-mockups---hifi"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="2---Create-Pod-pg-1" transform="translate(-1301.000000, -87.000000)">
          <g id="ico/close/34" transform="translate(1301.000000, 87.000000)">
            <g>
              <circle id="Oval" fill="#EDEDED" cx="25.5"
                cy="25.5" r="25.5"
              />
              <g
                id="Group-8"
                transform="translate(16.500000, 16.500000)"
                stroke="#3399CC"
                strokeLinecap="round"
                strokeWidth="1.5"
              >
                <path d="M0.673076923,0.673076923 L17.1214692,17.1214692" id="Line-3" />
                <path d="M0.378530836,0.673076923 L16.8269231,17.1214692" id="Line-3" transform="translate(8.602727, 8.897273) scale(-1, 1) translate(-8.602727, -8.897273) " />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
